import { RESET } from '../types';

export default function resetPreAuth3DS() {
  return {
    type: RESET,
  };
}
